import { Subscription } from '../../../../shared/types/BotUsers'
import { PropertyValueType } from '../../../BotUserProfile/types'
import { PropertyFieldType } from '../../../Flow/logic/FlowEnums'

export enum UserProfileState {
  Disabled = 'Disabled',
  Active = 'Active',
}

export type ReferrerUser = {
    id: number
    type: "USER"
    login: string
    name: string
    language: 'ru' | 'en'
    avatar_url: string
}

export type User = {
	user_id: number
	avatar_url: string
	login?: string | null
	name?: string
	language?: string
	utm?: {
		id: number
		value: string
	}
	referrer?: ReferrerUser
  labels: Array<number>
	banned: boolean
	lastActionTime?: string
	state: UserProfileState
	created: string
  potential_customer: boolean
  customer: boolean
}

export type UserProfile = Omit<User, 'labels'> & {
	distributions: number
	properties: UserProfileProperties
	subscriptions?: Array<Subscription>
  labels: { [ key:number ]: string }
	/**
	 * Время получения последней рассылки
	 */
	sent?: string
}

export type UserProfileProperties = {
	system: Array<UserProfileProperty>
	custom: Array<UserProfileProperty>
}

export type UserProfileProperty = {
	property : {
		id: number
		type: PropertyFieldType
		name: string
		options: Array<any> | null
    automatic?: boolean
	}
  value: PropertyValueType
}
